import { useEffect, useMemo, useState } from "react";

import { useComponentLogger } from "~/libs/logger";

export const useAntdIcon = (name: string) => {
  /** Component */
  const [Component, setComponent] = useState<any>();
  /** Keys for custom icons */
  const [customKeys, setCustomKeys] = useState<string[]>([]);

  /** Logger */
  const logger = useComponentLogger("AntdIcon");

  useEffect(() => {
    // Load custom keys dynamically to avoid static/dynamic import conflict
    import("./custom")
      .then((module: any) => {
        setCustomKeys(module.keys || []);
      })
      .catch((error) => {
        logger.error("Error loading custom keys:", error);
        setCustomKeys([]);
      });
  }, [logger]);

  useEffect(() => {
    if (customKeys.length === 0) return; // Wait for keys to load

    if (customKeys.includes(name)) {
      import("./custom")
        .then((module: any) => {
          setComponent(() => module.default[name]);
        })
        .catch((error) => {
          logger.error("Error loading custom component:", error);
        });
    } else {
      import("@ant-design/icons")
        .then((module: any) => {
          setComponent(() => module[name]);
        })
        .catch((error) => {
          logger.error("Error loading antd component:", error);
        });
    }
  }, [name, customKeys, logger]);

  /** return */
  return useMemo(
    () => ({
      states: {
        Component,
      },
    }),
    [Component]
  );
};
